import { adminApiRequest } from "../../utils/apiUtils";

export interface ImagePopupResponse {
  id: number;
  imagePath: string;
  ord: number;
  buttonText: string;
  buttonUrl: string;
}

export interface ImagePopupRequest {
  buttonText: string;
  buttonUrl: string;
}

export interface ImagePopupSortRequest {
  id: number;
  ord: number;
}

export const ImagePopupAPI = {
  getImagePopupList: () => adminApiRequest.get(`/image-popup`),
  deleteImagePopup: (id: number) =>
    adminApiRequest.delete(`/image-popup/${id}`),
  registerImagePopup: (formData: FormData) =>
    adminApiRequest.post(`/image-popup`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateImagePopup: (id: number, formData: FormData) =>
    adminApiRequest.put(`/image-popup/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  sortImagePopup: (body: ImagePopupSortRequest) =>
    adminApiRequest.put(`/image-popup/sort`, body),
};
